<app-loading *ngIf="loading"></app-loading>
<ng-container [style]="loading ? 'display: none;' : 'display: block;'">
    <ng-container *ngIf="withFormGroups else noFormGroups">
        <app-form-group title="Général">
            <ng-template template-content>
                <ng-container [ngTemplateOutlet]="general"></ng-container>
            </ng-template>
        </app-form-group>

        <app-form-group title="Contact">
            <ng-template template-content>
                <ng-container [ngTemplateOutlet]="contact"></ng-container>
            </ng-template>
        </app-form-group>
    </ng-container>

    <ng-template #noFormGroups>
        <ng-container [ngTemplateOutlet]="general"></ng-container>
        <ng-container [ngTemplateOutlet]="contact"></ng-container>
    </ng-template>
</ng-container>

<ng-template #general>
    <div class="row m-l-4">
        <app-form-field label="Nom" [required]="true">
            <app-input-text parentFormControlName="lastName" [parentFormGroup]="formGroup" (changedEvent)="nameUpdated()"></app-input-text>
        </app-form-field>
        <app-form-field label="Prénom" [required]="true">
            <app-input-text parentFormControlName="firstName" [parentFormGroup]="formGroup" (changedEvent)="nameUpdated()"></app-input-text>
        </app-form-field>
        <app-form-field label="Civilité" [required]="true">
            <app-civility-select-filter  [parentFormGroup]="formGroup" parentFormControlName="civility"
                                        style="width: 100%;"
                                        (singleSelectionChangedEvent)="nameUpdated()"></app-civility-select-filter>
        </app-form-field>

        <app-form-field label="Titre" [required]="true" *ngIf="displayTitleValue">
            <app-person-title-select-filter (singleSelectionChangedEvent)="nameUpdated()" [parentFormGroup]="formGroup" parentFormControlName="titleValue"
                                            style="width: 100%;"></app-person-title-select-filter>
        </app-form-field>

        <app-form-field label="Date de naissance" [required]="birthDateRequired">
            <div style="display: flex; justify-content: flex-end;">
                <app-date-picker [birthDate]="true" [parentFormGroup]="formGroup"
                                 parentFormControlName="birthDate" style="width: 100%;"></app-date-picker>
                <app-age-label [date]="birthDateFormCtrl.value" *ngIf="birthDateFormCtrl.valid" style="min-width: 50px;"></app-age-label>
            </div>

        </app-form-field>
        <app-form-field label="Décédé" *ngIf="displayDeadControl === true">
            <app-checkbox-input [parentFormGroup]="formGroup" parentFormControlName="dead"></app-checkbox-input>
        </app-form-field>
    </div>
</ng-template>


<ng-template #contact>
    <div class="row m-l-4">
        <app-form-field label="Adresse e-mail">
            <app-email-input parentFormControlName="email" [parentFormGroup]="formGroup"></app-email-input>
        </app-form-field>
    </div>
    <div class="row m-l-4">
        <app-form-field label="Tél principal">
            <app-phone-input [country]="account?.country"
                             [parentFormGroup]="phone"
                             [initialPayload]="phonePayload"
                             #phoneComponent></app-phone-input>
        </app-form-field>
        <app-form-field label="GSM">
            <app-phone-input
                    [country]="account?.country"
                    [parentFormGroup]="mobilePhone"
                    [initialPayload]="mobilePhonePayload"
                             #mobilePhoneComponent></app-phone-input>
        </app-form-field>
        <app-form-field label="Tel bureau">
            <app-phone-input [parentFormGroup]="officePhone"
                             [country]="account?.country"
                             [initialPayload]="officePhonePayload"
                             #officePhoneComponent></app-phone-input>
        </app-form-field>
    </div>
</ng-template>
